import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './_services';
import { first } from 'rxjs/operators';
import { User } from './_models';
import { HttpClient } from '@angular/common/http';
import { LogService } from './_shared/log.service';
import { HostListener } from '@angular/core';
import { queryModel } from './_models/queryModel';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DisputeService } from './_services/dispute.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({ selector: 'app', templateUrl: 'app.component.html' })
export class AppComponent {

  title = 'datatables';
  dtOptions: DataTables.Settings = {};
  posts;
  returnUrl: string;
  getresponse: any;
  rDown = false;
  queryModel = new queryModel();
  QueryForm: FormGroup;
  submitted = false;
  query;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true
    };

    this.QueryForm = this.formBuilder.group({

      query: ['', Validators.required],
    });

    const url = window.location.href;

    if (url.includes("student") || url.includes("employer") || url.includes("verifier") || url.includes("superVerifier") || url.includes("university") || url.includes("associate") || url.includes("superAssociate") || url.includes("superAdmin")) {
      console.log("url", url);
      let tkn = localStorage.getItem('token');
      let roleFromBrowser = localStorage.getItem('role');

      if (tkn == null || tkn == "") {
        this.logout();
      }
      console.log('roleFromBrowser', roleFromBrowser);
      if (url.includes("student")) {
        if (roleFromBrowser != ("student")) {
          this.logout();
        }
      }
      if (url.includes("employer")) {
        if (roleFromBrowser != ("employer")) {
          this.logout();
        }
      }
      if (url.includes("verifier")) {
        if (roleFromBrowser != ("verifier")) {
          this.logout();
        }
      }
      if (url.includes("superVerifier")) {
        if (roleFromBrowser != ("superVerifier")) {
          this.logout();
        }
      }
      if (url.includes("university")) {
        if (roleFromBrowser != ("university")) {
          this.logout();
        }
      }
      if (url.includes("associate")) {
        if (roleFromBrowser != ("associate")) {
          this.logout();
        }
      }
      if (url.includes("superAssociate")) {
        if (roleFromBrowser != ("superAssociate")) {
          this.logout();

        }
      } if (url.includes("superAdmin")) {
        if (roleFromBrowser != ("superAdmin")) {
          this.logout();
        }
      }

     
    }
    else {
      if(url.includes("resetPassword")||(url.includes("emailVerification"))){
        
      }else{
      this.logout();
      }
    }
    // this.http.get('http://jsonplaceholder.typicode.com/posts')
    //   .subscribe(posts => {
    //     this.posts = posts;
    // });

  }

  roleId: string;
  currentUser: User;

  constructor(private disputeService: DisputeService,
    private SpinnerService: NgxSpinnerService,
    private eventService: LogService,
    private modalService: NgbModal,
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  get f() { return this.QueryForm.controls; }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  openQueryModal(){
    this.query = '';
  }

  gotoHOme() {
    this.roleId = localStorage.getItem('currentRole');
    //  alert(this.roleId);


    if (this.roleId == "1")//for student
    {
      this.callDispute("'0'")
      this.returnUrl = "student";
      this.router.navigate([this.returnUrl]);
    }
    else if (this.roleId == "2")//for employer
    {
      this.callDispute("'0'")
      this.returnUrl = "employer";
      this.router.navigate([this.returnUrl]);
    }
    // else if (this.roleId == "3")//for verifier
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "verifier";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "4")//for super verifier
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "superVerifier";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "5")//for  super Admin
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "superAdmin";
    //   this.router.navigate([this.returnUrl]);
    // }

    // else if (this.roleId == "6")//for super Associate
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "associate";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "7")//for university
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "university";
    //   this.router.navigate([this.returnUrl]);
    // }
    if (this.roleId == "3")//for verifier
    {
      this.callRoute('27');
    }
    else if (this.roleId == "4")//for super verifier
    {
      this.callRoute('28');
    }
    else if (this.roleId == "5")//for  super Admin
    {
      this.callRoute('29');
    }
    else if (this.roleId == "6")//for  Associate
    {
      this.callRoute('30');
    }
    else if (this.roleId == "8")//for super Associate
    {
      location.reload();
      // this.ngOnInit();
      // this.returnUrl = "superAssociate";
      // this.router.navigate([this.returnUrl]);
      // this.callRoute('31');
    }
    else if (this.roleId == "7")//for university
    {
      this.callRoute('26');
    }

  }
  logout() {
    this.authenticationService.logoutVeri()
      .pipe(first())
      .subscribe(
        response => {
          if (response) {
            this.getresponse = response;
          }
        })
    this.authenticationService.logout();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('userName');
    localStorage.removeItem('refreshToken');
    // this.router.navigate(['/login']);
    // this.returnUrl = "login";
    this.returnUrl = "verification";
    this.router.navigate([this.returnUrl]);
  }
  // @HostListener('window:beforeunload', ['$event'])
  //   onWindowClose(event: any): void {   
  //     this.logout();  
  //     event.preventDefault();
  //     event.returnValue = false;

  //  }

  sendQuery(event){
    this.submitted = true;
    if (this.QueryForm.invalid) {
      return;
    }
    this.queryModel.userid = localStorage.getItem('user_id');
    this.queryModel.query = this.query;
    console.log('--->',this.queryModel)
    this.SpinnerService.show();
    this.disputeService.sendQuery(this.queryModel)
      .pipe(first())
      .subscribe(
        data => {
          this.SpinnerService.hide();
          console.log("response---", data);
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)

        },
      )



  }


  refresh(){
    location.reload();
  }

  

  
}